import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';

import { useSelector } from '@app/hooks';

import { selectSidebarState } from '../../slice';

const MENU_OPENED_WIDTH = 280;
const MENU_CLOSED_WIDTH = 65;
const BLOCK_COUNT = 12;

export const PageFallbackSideMenu = () => {
  const sidebarOpened = useSelector(selectSidebarState);
  const containerWidth = sidebarOpened ? MENU_OPENED_WIDTH : MENU_CLOSED_WIDTH;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      p="12"
      gap="20"
      justifyContent="flex-start"
      width={containerWidth}
      minWidth={containerWidth}
      height="calc(100vh - 64px)"
      bgcolor="bg.light.primary"
      borderColor="stroke.primary"
      borderRight={1}
    >
      {Array.from({ length: BLOCK_COUNT }).map((_, i) => (
        <Skeleton key={i} variant="rect" width="100%" height={40} />
      ))}
    </Box>
  );
};
